import { connect } from 'react-redux'
import GeneratedLicenseDel from '../../components/GeneratedLicenses/GeneratedLicenseDel'
import {delLicense} from "../../actions/index";


const mapStateToProps = state => {
    return {

    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        delLicense: (id) => {
            return dispatch(delLicense(id));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(GeneratedLicenseDel);









